import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../../lib/api";

export default function AiSettings() {
  const [s, setS] = useState(null);

  useEffect(() => { api.get("/admin/ai/settings").then((r) => setS(r.data)).catch(() => toast.error("Failed to load settings")); }, []);

  const save = async () => {
    try {
      await api.put("/admin/ai/settings", s);
      toast.success("AI Assistant settings saved");
    } catch { toast.error("Save failed"); }
  };

  if (!s) return <div className="p-8 text-slate-400">Loading…</div>;

  const toggleLang = (code) => {
    const langs = s.languages.includes(code) ? s.languages.filter((l) => l !== code) : [...s.languages, code];
    setS({ ...s, languages: langs.length ? langs : ["en"] });
  };

  return (
    <div className="max-w-2xl space-y-5 p-4 sm:p-6" data-testid="ai-settings-page">
      <div>
        <h1 className="font-heading text-xl font-bold text-white">AI Assistant Settings</h1>
        <p className="text-sm text-slate-400">Model: {s.model} (OpenAI via Emergent Universal Key)</p>
      </div>

      <label className="flex items-center justify-between rounded-xl border border-adminborder bg-admincard p-4">
        <span className="text-sm font-semibold text-white">Assistant enabled on website</span>
        <button onClick={() => setS({ ...s, enabled: !s.enabled })} data-testid="ai-settings-enabled-toggle"
                className={`h-6 w-11 rounded-full p-0.5 transition-colors ${s.enabled ? "bg-saffron" : "bg-slate-600"}`}>
          <span className={`block h-5 w-5 rounded-full bg-white transition-transform ${s.enabled ? "translate-x-5" : ""}`} />
        </button>
      </label>

      <div className="rounded-xl border border-adminborder bg-admincard p-4">
        <p className="mb-2 text-sm font-semibold text-white">Welcome greeting</p>
        <textarea value={s.greeting} onChange={(e) => setS({ ...s, greeting: e.target.value })} rows={4}
                  data-testid="ai-settings-greeting"
                  className="w-full rounded-lg border border-adminborder bg-adminbg px-3 py-2 text-sm text-slate-200 outline-none focus:border-saffron" />
      </div>

      <div className="rounded-xl border border-adminborder bg-admincard p-4">
        <p className="mb-2 text-sm font-semibold text-white">Human handover helpline number</p>
        <input value={s.handover_number} onChange={(e) => setS({ ...s, handover_number: e.target.value })}
               data-testid="ai-settings-handover"
               className="w-full rounded-lg border border-adminborder bg-adminbg px-3 py-2 text-sm text-slate-200 outline-none focus:border-saffron" />
      </div>

      <div className="rounded-xl border border-adminborder bg-admincard p-4">
        <p className="mb-2 text-sm font-semibold text-white">Languages</p>
        <div className="flex gap-2">
          {[["en", "English"], ["te", "తెలుగు"], ["hi", "हिन्दी"]].map(([c, l]) => (
            <button key={c} onClick={() => toggleLang(c)} data-testid={`ai-settings-lang-${c}`}
                    className={`rounded-full px-4 py-1.5 text-xs font-bold transition-colors ${s.languages.includes(c) ? "bg-saffron text-white" : "border border-adminborder text-slate-300"}`}>
              {l}
            </button>
          ))}
        </div>
      </div>

      <button onClick={save} data-testid="ai-settings-save-btn"
              className="rounded-lg bg-saffron px-6 py-2.5 text-sm font-bold text-white hover:bg-saffron-hover">
        Save Settings
      </button>
    </div>
  );
}
